export default "__VITE_ASSET__57bzCT4b__"